<template>
  <div id="Home">
    <div class="h-4rem">
      <b-row class="text-center bg-success text-light"
          variant="success" :hidden="successMessage == ''">
        <span class="h3 my-2 mx-auto">{{successMessage}}</span>
      </b-row>
      <b-row class="text-center bg-warning text-light"
          variant="success" :hidden="errorMessage == ''">
        <span class="h3 mx-auto">{{errorMessage}}</span>
      </b-row>


    </div>


    <div class="container pb-5">
      <b-row>
        <b-col>
          <p class="display-4">
            Pretty Print
            <span class="text-muted h3 ml-4"
                  v-if="initialSyntax !== '' && initialSyntax !== 'Autodetect'">
              your {{ initialSyntax }}
            </span>
          </p>
          <p class="h5 text-muted">
            Prettify your JSON, XML, HTML, JavaScript, and CSS.
          </p>
        </b-col>

        <b-col class="mt-auto">
          <b-form  inline sm align-self="end" class="my-4-sm text-right">

            <div v-if="advancedSettingsVisible">
              <label class="mr-sm-2 h5" for="language">Indents: </label>
              <b-dropdown class="ml-2 mr-5" id="language" :text="indentSize">
                <b-dropdown-item-button @click="selectedSyntax = '2'">2</b-dropdown-item-button>
                <b-dropdown-item-button @click="selectedSyntax = '4'">4</b-dropdown-item-button>
              </b-dropdown>
            </div>
            <b-col  md="6" lg="6" class="text-right">

              <b-form-select
                              class=" no-focus"
                             variant="secondary"
                             :options="syntaxOptions"
                             id="language"
                             v-model="selectedSyntax"
                             @input="updatePlaceholder()">
              </b-form-select>
            </b-col>
            <b-col sm="12" md="6" lg="6" class="text-right">
              <b-button id="prettifyButton"
                        variant="success"
                        size="lg"
                        @click="prettyPrint"
                        :disabled="text == ''"
                        class="mr-0">
                Prettify
              </b-button>
            </b-col>

          </b-form>
          <b-row >
              <b-button variant="info" class="ml-4" v-if="saveEnabled">
                <span class="h5 pr-3">Save</span>
                <icon name="save" scale="3" @click="save"></icon>
              </b-button>
          </b-row>
        </b-col>

      </b-row>



      <b-row align-v="end" class="mt-4 mb-1">
        <b-col class="text-left">
          <b-button variant="info"
                      @click="copy"
                      :disabled="text == ''"
                      v-if="prettied && text !== ''"
                      size="sm">
            <strong class=" pr-2">Copy</strong>
            <icon name="copy" ></icon>
          </b-button>
        </b-col>
        <b-col class="text-right" >
          <b-row class="mb-auto">
          </b-row>
          <b-row>
            <b-col class="mt-auto">
            <b-badge pill
                        variant="dark"
                      v-if="detectedLanguage">
              {{ detectedLanguage }} detected
            </b-badge>
            </b-col>
          </b-row>

        </b-col>
      </b-row>

      <b-row>
        <b-textarea
                  class="no-focus"
                  id="codeinput"
                        ref="codeinput"
                        rows="15"
                        :placeholder="textareaPlaceholder"
                        v-model="text"
                        v-bind:class="{hideText: text == '' && !textAreaFocused}"
                        @focus.native="codeInputFocused()"
                        @blur.native="codeInputBlurred()"
                        @change.native="codeInputtedText()"
                        @keyup.native="codeInputtedText()"
                        @paste.native="codeInputtedText()"
                        v-autosize="text">
        </b-textarea>
      </b-row>
    </div>
  </div>

</template>

<script>
var beautify_js = require('js-beautify') // also available under "js" export
var beautify_css = require('js-beautify').css
var beautify_html = require('js-beautify').html
var lang = require('language-classifier');
import hljs from 'highlight.js'
import autosize from 'autosize'

const _ = require('lodash')

export default {
  name: 'home',
  data() {
    return {
      text: '',
      successMessage: '',
      errorMessage: '',
      prettied: false,
      indentSize: 4,
      advancedSettingsVisible: false,
      textareaPlaceholder: 'Enter your ugly text here...',
      saveEnabled: false,
      selectedSyntax: '',
      supportedSyntaxes: [
        'JSON', 'HTML', 'XML', 'JavaScript', 'CSS'
      ],
      textAreaFocused: false
    }
  },
  props: {
    initialSyntax: {
      type: String,
      required: false,
      default: 'Autodetect'
    }
  },
  components: {
  },
  computed: {
    detectedLanguage() {
      if(this.text !== '') {
        lang = hljs.highlightAuto(this.text, this.supportedSyntaxes).language
        return lang

        //return lang(this.text);
      }
      else {
        return null
      }
    },
    syntaxOptions() {
      var opts = {'Autodetect': 'Autodetect'}

      _.forEach(
        this.supportedSyntaxes,
        item => opts[item] = item
      )
      return opts
    }
  },
  mounted() {
    this.updatePlaceholder()
    if(this.initialSyntax !== 'Autodetect'){
      this.selectedSyntax = _.upperCase(this.initialSyntax)
    }
    else {
      this.selectedSyntax = this.initialSyntax
    }
  },
  methods: {
    updatePlaceholder() {
      if(this.selectedSyntax !== 'Autodetect') {
        this.textareaPlaceholder = 'Enter your ugly '+this.selectedSyntax+' text here...'
      }
      else {
        this.textareaPlaceholder = 'Enter your ugly text here...'
      }
    },
    copy() {
      this.$copyText(this.text)
        .then(() => {
          this.onSuccess("Copied to clipboard")
        }, () => {
          this.onError('Error copying text. Please Try Again later.')
        })
    },
    onError(message) {
      this.errorMessage = message

      setTimeout(() => {
        this.errorMessage = ''

      }, 3000)
    },
    onSuccess(message) {
      this.successMessage = message

      setTimeout(() => {
        this.successMessage = ''
      }, 3000)
    },
    save() {

    },
    prettyPrint() {
      var html_types = ['HTML', 'XML']
      var js_types = ['JavaScript', 'JSON']
      var css_types = ['CSS']

      if(html_types.indexOf(this.selectedSyntax) > -1) {
        this.text = beautify_html(this.text, { indent_size: this.indentSize,  space_in_empty_paren: true  })
        this.prettied = true
      }
      else if(js_types.indexOf(this.selectedSyntax) > -1) {
        this.text = beautify_js(this.text, { indent_size: this.indentSize,  space_in_empty_paren: true  })
        this.prettied = true
      }
      else if(css_types.indexOf(this.selectedSyntax) > -1) {
        this.text = beautify_css(this.text, { indent_size: this.indentSize,  space_in_empty_paren: true  })
        this.prettied = true
      }
      //hljs.highlightBlock(this.$refs.codeinput);
    },
    codeInputFocused() {
      console.log('focused')
      this.textareaPlaceholder = ''
      this.textAreaFocused = true
    },
    codeInputBlurred() {
      this.updatePlaceholder()
      this.textAreaFocused = false
    },
    codeInputtedText(){
      autosize.update(this.$refs.codeinput)

      if(this.selectedSyntax == 'Autodetect') {
        var langUppercase = _.upperCase(this.detectedLanguage)
        if (this.supportedSyntaxes.indexOf(langUppercase) > -1) {
          this.selectedSyntax = langUppercase
        }
      }
    }
  },
  head: {
    title: {
      inner: 'Pretty Print',
      complement: 'JSON, XML, HTML, CSS'
    },
  }
}
</script>

<style lang="sass">

#prettifyButton
  width: 100%

.hideText
  color: transparent !important
  text-shadow: 0 0 0 gray
  border: none

#language
  &:focus
    border-color: inherit
    -webkit-box-shadow: none
    box-shadow: none


#codeinput
  background-color: grey
  color: white
  resize: auto

  &:focus
    border-color: inherit
    -webkit-box-shadow: none
    box-shadow: none


  &::-webkit-input-placeholder
    color: white
  &:-moz-placeholder
    color: white

  &::-moz-placeholder
    color: white

  &:-ms-input-placeholder
    color: white

  &::placeholder
    color: white

.h-40
  height: 40px

.mr-0
  margin-right: 0

.h-100
  height: 100px

.h-4rem
  height: 4rem
</style>
